module.exports = "query GetGroup($id: ID!) {\n  group(id: $id) {\n    ...DetailedGroupFragment\n  }\n}\n"